import { StorageTierLabels } from './models/storage-tier';

export class StorageTierService {
	static getStorageTierOptions(): { value: string; label: string }[] {
		return Object.entries(StorageTierLabels).map(([value, label]) => ({ label, value }));
	}
}
